import React, { useState } from 'react';

const MustReadGuidelines = () => {
  const [openSection, setOpenSection] = useState(null);

  const guidelines = [
    {
      title: 'Minimum Trade Size Requirements',
      content: (
        <div>
        <p>To ensure your trades are executed properly, please adhere to the following minimum dollar trade size guidelines:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Single-leg trades (SPY or QQQ): Minimum $250</li>
          <li>Spread trades (SPY or QQQ): Minimum $150</li>
          <li>SPX spread trades: Minimum $500</li>
          
        </ul>
        <p>Failure to meet these minimums will most likely result in missed trades, as the position size will fall below the required capital threshold necessary for execution.</p>
      </div>
      ),
    },
    {
      title: 'Margin vs Cash Accounts',
      content: (
        <div>
          <p>No Margin Required.</p>
          <p>The Quantum Flo Auto Algo only buys Calls and Puts or Spreads, which are cash-secured trades. Because we are not selling options or using complex margin strategies, a margin account is not required. The strategy can be executed in either a cash or margin account, but no margin is ever used.</p>
          
        </div>
      ),
    },
    
    {
      title: 'Trading Limits',
      content: (
        <div>
          <p>Tier-Based Access. Symbol-Specific Execution.</p>
          <p>Your subscription level determines the maximum dollars you can trade per symbol per trade per day. This ensures fair use of the system and helps manage liquidity across our growing client base.</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Your daily trading limit is based on your Tier level.</li>
            <li>The Quantum Flo Auto Algo currently supports SPY, QQQ, and SPX only. No other symbols will be traded.</li>
            <li>You may not exceed your allocated maximum dollar limit per symbol per trade.</li>
            <li>To increase your daily trading capacity, contact your representative about upgrading your Tier.</li>
            <li>If you allocate more trading capital than your account balance allows, the application will automatically pause and will not execute any additional trades. To resolve this issue, please contact our support team at CustomerSupport@JTNCGroup.com for assistance.</li>
          </ul>
        </div>
      ),
    },
    
    
    
    {
      title: 'Risk Management',
      content: (
        <div>
          <p><strong>Diversify to Reduce Risk.</strong></p>
          <p>Diversification means spreading your trades across multiple symbols to help reduce overall risk. While the QF Auto Algo currently trades only SPY, QQQ, and SPX, the <strong>principle remains the same</strong></p>
          <p><strong>The more distinct opportunities you trade, the more balanced your risk becomes.</strong></p>
          <p>As we expand the platform to include additional products (stocks, futures, crypto), we strongly encourage clients to <strong>trade multiple symbols</strong> to maximize performance consistency and limit single-symbol exposure.</p>
        </div>
      ),
    },
    
    {
      title: 'Trade Timing',
      content: (
        <div>
          <p><strong>Trades are entered and exited based on real-time market conditions, not a fixed schedule.</strong></p>
          <p>The Quantum Flo Auto Algo continuously monitors price action, options flow, and sentiment shifts to identify <strong>high-probability setups.</strong> This means trades are <strong>triggered dynamically</strong>, only when specific criteria are met.</p>
          <p>Most trades are <strong>entered between 9:45 AM and 2:30 PM ET,</strong> after early market volatility has settled.</p>
          <p><strong>Holding periods</strong> are typically less than two days, with many trades closing the same day.</p>
          <p><strong>Trades are never held over the weekend,</strong> helping you avoid unpredictable gap risk from macro news or global events.</p>
          <p>This active and adaptive timing model is designed to <strong>capture intraday and short-term price moves</strong> while <strong>minimizing overnight and event-driven risk.</strong></p>
        </div>
      ),
    },
    
    {
      title: 'Existing Positions',
      content: (
        <div>
          <p><strong>Avoid Conflicts with Manual Trades.</strong></p>
          <p>If you already hold an open position in SPY, QQQ, or SPX, the Quantum Flo Auto Algo may initiate trades that result in the partial or full sale of those positions.</p>
          <p>To prevent conflicts between your manual trades and the algorithm:</p>
          <p><strong>Avoid holding positions</strong> in these symbols while the algo is active.</p>
          <p>If you wish to maintain control over certain trades, <strong>pause the algo or segregate accounts.</strong></p>
          <p>Maintaining a clean slate ensures the bot can operate without interference and follow its logic as intended.</p>
        </div>
      ),
    },
    
    {
      title: 'Options Trading Level',
      content: (
        <div>
          <p><strong>Broker Approval Required.</strong></p>
          <p>To use the Quantum Flo Auto Algo, your brokerage account must have the appropriate options trading permissions enabled. Without the correct level, the algo will not be able to execute trades on your behalf.</p>
          <p><strong>Required Option Approval Levels by Broker:</strong></p>
          <p>- Tradier – Level 3</p>
          <p>- Schwab – Level 2</p>
          <p>- TastyTrade – Basic (Margin)</p>
        
          <p>If you're not currently approved, contact your broker to request an upgrade before activating the bot.</p>
        </div>
      ),
    },
    
   
    {
      title: 'Assignments',
      content: (
        <div>
          <p><strong>No Obligation. Limited Risk.</strong></p>
          <p>When you buy a call or put option as the Quantum Flo Auto Algo does, you are purchasing the right, but not the obligation, to buy or sell the underlying asset at a specific strike price before expiration.</p>
          <p>- You will never be forced to take delivery of the underlying asset.</p>
          <p>- You can choose not to exercise the option at expiration.</p>
          <p>- Your maximum loss is limited to the premium paid for the option, no more.</p>
          <p>Because the QF Auto Algo only buys options, there is no assignment risk beyond the cost of the trade itself.</p>
        </div>
      ),
    },
    
    
    
   
    
    
  ];

  return (
    <div className="bg-gray-800 p-4 rounded-lg mb-8">
      <h4 className="text-xl font-bold mb-2 text-white">Regulations</h4>
      {guidelines.map((section, index) => (
        <div key={index} className="space-y-2">
          <button
            onClick={() => setOpenSection(openSection === index ? null : index)}
            className="text-left text-purple-400 font-bold w-full" // เปลี่ยนสีตัวหนังสือเป็นสีม่วง
          >
            {section.title}
          </button>
          {openSection === index && (
            <div className="text-purple-300 text-sm mt-2"> {/* เปลี่ยนสีเนื้อหาเป็นสีม่วง */}
              {section.content}
            </div>
          )}
          {/* Add Border between sections */}
          <div className="border-b border-gray-600 my-2"></div>
        </div>
      ))}
    </div>
  );
};

export default MustReadGuidelines;
